<template>
<v-list-tile :disabled='isDeleting' >
  <v-list-tile-content v-if='statement' >
    <v-list-tile-title>{{statement.title}}</v-list-tile-title>
    <v-list-tile-sub-title>
      Date: {{statement.date}}
      <span class='hidden-xs-only' >Due: {{statement.due_date}}</span>
    </v-list-tile-sub-title>
  </v-list-tile-content>
  <v-list-tile-action >
    {{ formatCurrency(me.profile.currency, statement.closing_balance) }}
    <v-list-tile-action-text>
      Balance
    </v-list-tile-action-text>
  </v-list-tile-action>
  <v-divider class='ml-2' vertical >
  </v-divider>
  <v-list-tile-action >
    <v-btn
      :href='statement.url'
      target='_blank'
      :icon='$vuetify.breakpoint.xs'
      flat >
        <span class='hidden-xs-only' >View</span>
        <v-icon small class='ml-2' >open_in_new</v-icon>
    </v-btn>
  </v-list-tile-action>
  <v-list-tile-action>
    <v-btn
      :icon='$vuetify.breakpoint.xs' flat
      @click='$emit("send", statement)'
      color='primary' >
      <span class='hidden-xs-only' >Send</span>
      <v-icon small class='ml-2 visible-xs-only' >send</v-icon>
    </v-btn>
  </v-list-tile-action>
  <v-divider vertical ></v-divider>
  <v-list-tile-action style='min-width:40px;' >
    <v-btn
      @click='showDeleteConfirmation=true'
      :loading='loading'
      icon color='danger' >
      <v-icon>delete</v-icon>
    </v-btn>
    <v-dialog v-if='statement' v-model='showDeleteConfirmation' >
      <v-card>
        <v-card-title class='subtitle-1 overline' >
          Are you sure you want to delete this statement?
        </v-card-title>
        <v-card-text>
          Permanently delete statement: <strong>{{statement.title}}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-btn @click='showDeleteConfirmation=false' flat text >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color='error' @click='dodelete(statement.id);showDeleteConfirmation=false' >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile-action>
</v-list-tile>
</template>
<script>
export default {
  name: 'StatementListItem',
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      statement: {},
      delReqId: 'delete-statement-request',
      showDeleteConfirmation: false,
      loading: false,
      isDeleting: false
    }
  },
  mounted () {
    this.statement = this.value
  },
  methods: {
    dodelete (statementId) {
      this.loading = true
      this.isDeleting = true
      return this.$invoiceguru
        .resource('statements')
        .id(this.delReqId)
        .delete(statementId)
    }
  },
  watch: {
    deleteStatementRequestStatus () {
      if (this.deleteStatementRequestStatus === 204) {
        if (this.loading === true) {
          this.$emit('deleted', this.statement)
        }
        this.loading = false
      }
      if (this.deleteStatementRequestStatus >= 300) {
        window.alert('Unable to delete statement. Please try again')
        this.isDeleting = false
        this.loading = false
      }
    }
  },
  computed: {
    deleteStatementRequest () {
      return this.$store.getters.getRequestById(this.delReqId, true)
    },
    deleteStatementRequestStatus () {
      return this.deleteStatementRequest.status
    }
  }
}
</script>



// WEBPACK FOOTER //
// StatementListItem.vue?f7ecb848